import React from "react";
import Second from "../../../assets/photos/second.jpg";

const StudentsCareers = () => {
  return (
    <div className="w-full min-h-screen bg-gray-100">
     
            {/* Navigation Bar */}
           
    

      {/* Main Content */}
      <div className="flex flex-wrap lg:flex-nowrap w-full">
        {/* Left Section: Image */}
        <div className="w-full lg:w-1/2">
          <img
            src={Second}
            alt="Students at CodeQueue"
            className="w-full h-[300px] lg:h-[calc(100vh-64px)] object-cover"
          />
        </div>

        {/* Right Section: Centered Text */}
        <div className="w-full lg:w-1/2 flex flex-col justify-center px-6 lg:px-20 py-6">
          <h5 className="text-gray-500 uppercase text-sm mb-2 flex-col">
            Jumpstart Your Career
          </h5>
          <h1 className="text-3xl lg:text-5xl font-semibold text-blue-900 mb-4">
            Students & 
            <span className="block font-semibold">Graduates</span>
          </h1>
          <p className="text-blue-900 text-base lg:text-lg leading-relaxed py-4 mb-6">
            Explore our student opportunities and discover how you can make
            an impact at{" "}
            <span className="font-bold text-blue-900">CodeQueue</span>. From{" "}
            <span className="font-bold text-blue-900">internships</span>, to{" "}
            <span className="font-bold text-blue-900">apprenticeships</span>, to{" "}
            <span className="font-bold text-blue-900">graduate programmes</span>, we offer a
            range of options to help you launch your career in the exciting
            world of <span className="font-bold text-blue-900">Mentorship</span>.
          </p>
          <p className="font-bold text-blue-900 mb-6">
            Take the first step towards an inspiring career with 
            <span className="block">CodeQueue.</span>
          </p>
          <button className="bg-black text-white px-4 py-3 rounded hover:bg-gray-800 transition duration-300">
            Embark on student adventure
          </button>
        </div>
      </div>
    </div>
  );
};

export default StudentsCareers;